import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import './TamilKeyBoardStyles.css';

const tamilRows = [
  ['அ', 'ஆ', 'இ', 'ஈ', 'உ', 'ஊ', 'எ', 'ஏ'],
  ['ஐ', 'ஒ', 'ஓ', 'ஔ', 'ஃ', 'க்', 'ங்', 'ச்'],
  ['ஞ்', 'ட்', 'ண்', 'த்', 'ந்', 'ப்', 'ம்', 'ய்'],
  ['ர்', 'ல்', 'வ்', 'ழ்', 'ள்', 'ற்', 'ன்', 'ஜ்'],
  ['ஷ்', 'ஸ்', 'ஹ்', 'க்ஷ்'],
];

const extendedCharacters = {
  க்: ['க்', 'க', 'கா', 'கி', 'கீ', 'கு', 'கூ', 'கெ', 'கே', 'கை', 'கொ', 'கோ', 'கௌ'],
  ங்: ['ங்', 'ங', 'ஙா', 'ஙி', 'ஙீ', 'ஙு', 'ஙூ', 'ஙெ', 'ஙே', 'ஙை', 'ஙொ', 'ஙோ', 'ஙௌ'],
  ச்: ['ச்', 'ச', 'சா', 'சி', 'சீ', 'சு', 'சூ', 'செ', 'சே', 'சை', 'சொ', 'சோ', 'சௌ'],
  ஞ்: ['ஞ்', 'ஞ', 'ஞா', 'ஞி', 'ஞீ', 'ஞு', 'ஞூ', 'ஞெ', 'ஞே', 'ஞை', 'ஞொ', 'ஞோ', 'ஞௌ'],
  ட்: ['ட்', 'ட', 'டா', 'டி', 'டீ', 'டு', 'டூ', 'டெ', 'டே', 'டை', 'டொ', 'டோ', 'டௌ'],
  ண்: ['ண்', 'ண', 'ணா', 'ணி', 'ணீ', 'ணு', 'ணூ', 'ணெ', 'ணே', 'ணை', 'ணொ', 'ணோ', 'ணௌ'],
  த்: ['த்', 'த', 'தா', 'தி', 'தீ', 'து', 'தூ', 'தெ', 'தே', 'தை', 'தொ', 'தோ', 'தௌ'],
  ந்: ['ந்', 'ந', 'நா', 'நி', 'நீ', 'நு', 'நூ', 'நெ', 'நே', 'நை', 'நொ', 'நோ', 'நௌ'],
  ப்: ['ப்', 'ப', 'பா', 'பி', 'பீ', 'பு', 'பூ', 'பெ', 'பே', 'பை', 'பொ', 'போ', 'பௌ'],
  ம்: ['ம்', 'ம', 'மா', 'மி', 'மீ', 'மு', 'மூ', 'மெ', 'மே', 'மை', 'மொ', 'மோ', 'மௌ'],
  ய்: ['ய்', 'ய', 'யா', 'யி', 'யீ', 'யு', 'யூ', 'யெ', 'யே', 'யை', 'யொ', 'யோ', 'யௌ'],
  ர்: ['ர்', 'ர', 'ரா', 'ரி', 'ரீ', 'ரு', 'ரூ', 'ரெ', 'ரே', 'ரை', 'ரொ', 'ரோ', 'ரௌ'],
  ல்: ['ல்', 'ல', 'லா', 'லி', 'லீ', 'லு', 'லூ', 'லெ', 'லே', 'லை', 'லொ', 'லோ', 'லௌ'],
  வ்: ['வ்', 'வ', 'வா', 'வி', 'வீ', 'வு', 'வூ', 'வெ', 'வே', 'வை', 'வொ', 'வோ', 'வௌ'],
  ழ்: ['ழ்', 'ழ', 'ழா', 'ழி', 'ழீ', 'ழு', 'ழூ', 'ழெ', 'ழே', 'ழை', 'ழொ', 'ழோ', 'ழௌ'],
  ள்: ['ள்', 'ள', 'ளா', 'ளி', 'ளீ', 'ளு', 'ளூ', 'ளெ', 'ளே', 'ளை', 'ளொ', 'ளோ', 'ளௌ'],
  ற்: ['ற்', 'ற', 'றா', 'றி', 'றீ', 'று', 'றூ', 'றெ', 'றே', 'றை', 'றொ', 'றோ', 'றௌ'],
  ன்: ['ன்', 'ன', 'னா', 'னி', 'னீ', 'னு', 'னூ', 'னெ', 'னே', 'னை', 'னொ', 'னோ', 'னௌ'],
  ஜ்: ['ஜ்', 'ஜ', 'ஜா', 'ஜி', 'ஜீ', 'ஜு', 'ஜூ', 'ஜெ', 'ஜே', 'ஜை', 'ஜொ', 'ஜோ', 'ஜௌ'],
  ஷ்: ['ஷ்', 'ஷ', 'ஷா', 'ஷி', 'ஷீ', 'ஷு', 'ஷூ', 'ஷெ', 'ஷே', 'ஷை', 'ஷொ', 'ஷோ', 'ஷௌ'],
  ஸ்: ['ஸ்', 'ஸ', 'ஸா', 'ஸி', 'ஸீ', 'ஸு', 'ஸூ', 'ஸெ', 'ஸே', 'ஸை', 'ஸொ', 'ஸோ', 'ஸௌ'],
  ஹ்: ['ஹ்', 'ஹ', 'ஹா', 'ஹி', 'ஹீ', 'ஹு', 'ஹூ', 'ஹெ', 'ஹே', 'ஹை', 'ஹொ', 'ஹோ', 'ஹௌ'],
  க்ஷ்: ['க்ஷ்', 'க்ஷ', 'க்ஷா', 'க்ஷி', 'க்ஷீ', 'க்ஷு', 'க்ஷூ', 'க்ஷெ', 'க்ஷே', 'க்ஷை', 'க்ஷொ', 'க்ஷோ', 'க்ஷௌ'],
};

function TamilKeyboard({ onKeyPress, resetSignal }) {
  const rootRef = useRef(null);
  const popupRef = useRef(null);

  const [popupData, setPopupData] = useState(null);
  const [popupStyle, setPopupStyle] = useState({
    visibility: 'hidden',
    top: 0,
    left: 0,
  });

  const closePopup = useCallback(() => {
    setPopupData(null);
    setPopupStyle({
      visibility: 'hidden',
      top: 0,
      left: 0,
    });
  }, []);

  useEffect(() => {
    closePopup();
  }, [resetSignal, closePopup]);

  const computePopupPosition = useCallback(() => {
    if (!popupData || !popupRef.current || !rootRef.current) {
      return;
    }

    const rootRect = rootRef.current.getBoundingClientRect();
    const popupRect = popupRef.current.getBoundingClientRect();

    const gap = 8;
    const edgePadding = 6;

    const rootHeight = rootRect.height;
    const rootWidth = rootRect.width;
    const popupHeight = popupRect.height;
    const popupWidth = popupRect.width;

    const targetTop = popupData.targetTop;
    const targetBottom = popupData.targetBottom;
    const targetCenterX = popupData.targetCenterX;

    const canShowBelow =
      targetBottom + gap + popupHeight <= rootHeight - edgePadding;

    const canShowAbove = targetTop - gap - popupHeight >= edgePadding;

    const spaceBelow = rootHeight - targetBottom - gap;
    const spaceAbove = targetTop - gap;

    let rawTop;

    if (canShowBelow) {
      rawTop = targetBottom + gap;
    } else if (canShowAbove) {
      rawTop = targetTop - popupHeight - gap;
    } else if (spaceBelow >= spaceAbove) {
      rawTop = targetBottom + gap;
    } else {
      rawTop = targetTop - popupHeight - gap;
    }

    const maximumTop = Math.max(edgePadding, rootHeight - popupHeight - edgePadding);
    const nextTop = Math.min(Math.max(rawTop, edgePadding), maximumTop);

    const rawLeft = targetCenterX - popupWidth / 2;
    const maximumLeft = Math.max(edgePadding, rootWidth - popupWidth - edgePadding);
    const nextLeft = Math.min(Math.max(rawLeft, edgePadding), maximumLeft);

    setPopupStyle({
      visibility: 'visible',
      top: Math.round(nextTop),
      left: Math.round(nextLeft),
    });
  }, [popupData]);

  useLayoutEffect(() => {
    if (!popupData) {
      return undefined;
    }

    const frameId = window.requestAnimationFrame(() => {
      computePopupPosition();
    });

    window.addEventListener('resize', computePopupPosition);
    window.addEventListener('orientationchange', computePopupPosition);
    window.addEventListener('scroll', computePopupPosition, true);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.removeEventListener('resize', computePopupPosition);
      window.removeEventListener('orientationchange', computePopupPosition);
      window.removeEventListener('scroll', computePopupPosition, true);
    };
  }, [popupData, computePopupPosition]);

  useEffect(() => {
    const handleOutsidePointerDown = (event) => {
      if (!popupData) {
        return;
      }

      if (popupRef.current && popupRef.current.contains(event.target)) {
        return;
      }

      if (rootRef.current && rootRef.current.contains(event.target)) {
        return;
      }

      closePopup();
    };

    document.addEventListener('pointerdown', handleOutsidePointerDown, true);

    return () => {
      document.removeEventListener('pointerdown', handleOutsidePointerDown, true);
    };
  }, [popupData, closePopup]);

  const handleMainKeyClick = (event, key) => {
    const variants = extendedCharacters[key];

    if (!variants) {
      closePopup();

      if (typeof onKeyPress === 'function') {
        onKeyPress(key);
      }

      return;
    }

    if (!rootRef.current) {
      return;
    }

    const rootRect = rootRef.current.getBoundingClientRect();
    const targetRect = event.currentTarget.getBoundingClientRect();

    setPopupData({
      key,
      variants,
      targetTop: targetRect.top - rootRect.top,
      targetBottom: targetRect.bottom - rootRect.top,
      targetCenterX: targetRect.left - rootRect.left + targetRect.width / 2,
    });

    setPopupStyle({
      visibility: 'hidden',
      top: 0,
      left: 0,
    });
  };

  const handlePopupKeyClick = (key) => {
    if (typeof onKeyPress === 'function') {
      onKeyPress(key);
    }

    closePopup();
  };

  return (
    <div className="tamil-keyboard-wrapper" ref={rootRef}>
      <div className="tamil-keyboard-grid">
        {tamilRows.map((row, rowIndex) => (
          <div className="tamil-keyboard-row" key={`tamil-row-${rowIndex}`}>
            {row.map((key) => (
              <button
                type="button"
                className="tamil-keyboard-key"
                key={key}
                onMouseDown={(event) => event.preventDefault()}
                onClick={(event) => handleMainKeyClick(event, key)}
              >
                {key}
              </button>
            ))}
          </div>
        ))}
      </div>

      {popupData ? (
        <div
          className="tamil-keyboard-popup"
          ref={popupRef}
          style={{
            visibility: popupStyle.visibility,
            top: `${popupStyle.top}px`,
            left: `${popupStyle.left}px`,
          }}
        >
          {popupData.variants.map((key) => (
            <button
              type="button"
              className="tamil-keyboard-popup-key"
              key={`${popupData.key}-${key}`}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => handlePopupKeyClick(key)}
            >
              {key}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default TamilKeyboard;